import React from 'react';

import { Loader } from '../loader';

export type LoadingIndicatorProps = {
  message?: string;
  showMessage?: boolean;
};

export const LoadingIndicator = ({
  message = 'Loading, please wait...',
  showMessage = true,
}) => (
  <div className="space-y-2 text-center">
    <Loader className="w-16 h-16 mx-auto" />
    {showMessage && (
      <div className="text-teal-500 text-lg font-medium">{message}</div>
    )}
  </div>
);
